<div *ngIf="registrationComplete" class="success-root">
  <div class="success-card">
    <div class="success-content">
      <!-- Icon Container -->
      <div class="success-icon-container">
        <div class="success-icon-bg-circle bg1"></div>
        <div class="success-icon-bg-circle bg2"></div>
        <svg class="success-custom-svg-icon" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="shield-success" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
              <stop stop-color="#22c55e"/>
              <stop offset="1" stop-color="#16a34a"/>
            </linearGradient>
          </defs>
          <path d="M28 6L48 14V26C48 39 36.5 47 28 50C19.5 47 8 39 8 26V14L28 6Z" fill="url(#shield-success)"/>
          <path d="M20 29L26 35L36 23" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      
      <!-- Header -->
      <div class="success-header">
        <h1>Inscription réussie</h1>
        <div class="success-header-line"></div>
      </div>

      <!-- Success Content -->
      <div class="success-status">
        <h2>Bienvenue !</h2>
        <p>Votre compte a été créé avec succès.<br>Veuillez vérifier votre boîte e-mail pour activer votre compte.</p>
      </div>

      <!-- Actions -->
      <div class="success-actions">
        <a routerLink="/login" class="success-btn" tabindex="0">
          <span class="material-icons">login</span>
          <span>Aller à la connexion</span>
        </a>
      </div>
    </div>
  </div>
</div>

<div class="signup-container" *ngIf="!registrationComplete">
  <div class="signup-card">
    <!-- Header -->
    <div class="signup-header">
      <div class="logo">
        <i class="fa fa-cubes"></i>
      </div>
      <h1>Créer un compte</h1>
      <p>Rejoignez notre système de gestion de stock</p>
    </div>

    <!-- Error Message -->
    <div class="error-message" *ngIf="errorMessage">
      <i class="fa fa-exclamation-circle"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- Signup Form -->
    <form (ngSubmit)="onSubmit()" #signupForm="ngForm" class="signup-form">
      <!-- Name Row -->
      <div class="form-row">
        <div class="form-field">
          <label for="firstName">Prénom</label>
          <div class="input-wrapper">
            <i class="fa fa-user"></i>
            <input 
              type="text" 
              id="firstName"
              [(ngModel)]="firstName" 
              name="firstName" 
              placeholder="Votre prénom"
              required>
          </div>
        </div>

        <div class="form-field">
          <label for="lastName">Nom</label>
          <div class="input-wrapper">
            <i class="fa fa-user"></i>
            <input 
              type="text" 
              id="lastName"
              [(ngModel)]="lastName" 
              name="lastName" 
              placeholder="Votre nom"
              required>
          </div>
        </div>
      </div>

      <!-- Email -->
      <div class="form-field">
        <label for="email">Email</label>
        <div class="input-wrapper">
          <i class="fa fa-envelope"></i>
          <input 
            type="email" 
            id="email"
            [(ngModel)]="email" 
            name="email" 
            placeholder="votre@email.com"
            required>
        </div>
      </div>

      <!-- Username -->
      <div class="form-field">
        <label for="username">Nom d'utilisateur</label>
        <div class="input-wrapper">
          <i class="fa fa-user"></i>
          <input 
            type="text" 
            id="username"
            [(ngModel)]="username" 
            name="username" 
            placeholder="Choisissez un nom d'utilisateur"
            required>
        </div>
      </div>

      <!-- Role -->
      <div class="form-field">
        <label for="role">Rôle</label>
        <div class="input-wrapper">
          <i class="fa fa-briefcase"></i>
          <select 
            id="role"
            [(ngModel)]="role" 
            name="role"
            required>
            <option value="USER">Utilisateur</option>
            <option value="ADMIN">Administrateur</option>
          </select>
        </div>
      </div>

      <!-- Password Row -->
      <div class="form-row">
        <div class="form-field">
          <label for="password">Mot de passe</label>
          <div class="input-wrapper">
            <i class="fa fa-lock"></i>
            <input 
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              [(ngModel)]="password" 
              name="password" 
              placeholder="Votre mot de passe"
              (input)="checkPasswordComplexity()"
              required>
            <button 
              type="button" 
              class="password-toggle" 
              (click)="showPassword = !showPassword">
              <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
            </button>
          </div>
          
          <!-- Password Strength Indicator -->
          <div class="password-strength" *ngIf="password">
            <div class="strength-bar">
              <div class="strength-fill" 
                   [style.width.%]="getPasswordStrength()"
                   [style.background-color]="getPasswordStrengthColor()"></div>
            </div>
            <div class="strength-text">
              Force du mot de passe: {{ getPasswordStrength() | number:'1.0-0' }}%
            </div>
          </div>
        </div>

        <div class="form-field">
          <label for="confirmPassword">Confirmer</label>
          <div class="input-wrapper">
            <i class="fa fa-lock"></i>
            <input 
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              [(ngModel)]="confirmPassword" 
              name="confirmPassword" 
              placeholder="Confirmez le mot de passe"
              required>
            <button 
              type="button" 
              class="password-toggle" 
              (click)="showConfirmPassword = !showConfirmPassword">
              <i class="fa" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Password Requirements Sentence -->
      <div class="password-requirements" *ngIf="password">
        <ul>
          <li [class.valid]="passwordRequirements.minLength">
            <i class="fa" [class.fa-check]="passwordRequirements.minLength" [class.fa-times]="!passwordRequirements.minLength"></i>
            8 caractères
          </li>
          <li [class.valid]="passwordRequirements.hasUppercase">
            <i class="fa" [class.fa-check]="passwordRequirements.hasUppercase" [class.fa-times]="!passwordRequirements.hasUppercase"></i>
            Majuscule
          </li>
          <li [class.valid]="passwordRequirements.hasLowercase">
            <i class="fa" [class.fa-check]="passwordRequirements.hasLowercase" [class.fa-times]="!passwordRequirements.hasLowercase"></i>
            Minuscule
          </li>
          <li [class.valid]="passwordRequirements.hasNumber">
            <i class="fa" [class.fa-check]="passwordRequirements.hasNumber" [class.fa-times]="!passwordRequirements.hasNumber"></i>
            Chiffre
          </li>
          <li [class.valid]="passwordRequirements.hasSpecialChar">
            <i class="fa" [class.fa-check]="passwordRequirements.hasSpecialChar" [class.fa-times]="!passwordRequirements.hasSpecialChar"></i>
            Spécial
          </li>
        </ul>
      </div>

      <!-- Submit Button -->
      <button 
        type="submit" 
        class="login-button" 
        [disabled]="signupForm.invalid || isLoading"
        [class.loading]="isLoading">
        <span *ngIf="!isLoading">Créer le compte</span>
        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>
      </button>
    </form>

    <div class="divider">
      <span>ou</span>
    </div>

    <div class="signup-prompt">
      <p>Vous avez déjà un compte?</p>
      <a routerLink="/login" class="signup-link">
        Se connecter
      </a>
    </div>
  </div>
</div>